export default __webpack_public_path__ + "static/media/sudden_attack_banner.5f57d58e.png";